import { useEffect, useState } from "react";
import { YSButton } from "../../../uikit/YSButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
  BtnGroupStyle,
  ContentStyle,
  DRxInputStyle,
  greyColor,
  HtmlTooltip,
  SummaryBox,
  SummaryBoxScroll,
} from "../../../Theme";
import YSCheckBox from "../../../uikit/YSCheckBox";
import { Formik, Form } from "formik";
import TabsNav from "../../../components/TabsNav";
import { useLocation, useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import {
  MedicationHistorySendCancelRx,
  RemoveCancelRxByRxNumber,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { CircularProgress } from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

export default function CancelPrescriptions() {
  const doctorId: any = localStorage.getItem("doctorId");
  const patientId: any = sessionStorage.getItem("patientId");
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [applyAll, setApplyAll] = useState(false);
  const [selectedRxNumber, setSelectedRxNUmber] = useState<any>([]);
  const [sendCancelRxData, setSendCancelRxData] = useState<any>([]);
  const [stateData, setStateData] = useState<any>([]);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
    navigate("/medicationshistory");
  };
  const handleChangeCheckBox = (selectedValue: any, e: any) => {
    if (e.target.checked) {
      setSelectedRxNUmber([...selectedRxNumber, selectedValue]);
    } else {
      setSelectedRxNUmber(
        selectedRxNumber.filter((item: any) => item !== selectedValue)
      );
    }
  };
  const sendToCancelRx = async () => {
    try {
      setLoading(true);
      const bodyData = {
        prescriptionFormList: stateData,
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await MedicationHistorySendCancelRx(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setSendCancelRxData(result?.data?.response[0]);
        handleShowApprovedPopupClick();
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setSendCancelRxData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
      setSendCancelRxData([]);
    }
  };
  const removeCancelRx = async () => {
    try {
      const bodyData = {
        prescriptionFormList: state,
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
        prescriptionIds: selectedRxNumber,
      };
      const result = await RemoveCancelRxByRxNumber(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setStateData(result?.data?.response[0]?.prescriptionFormList);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (eor) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  useEffect(() => {
    if (state) {
      setStateData(state);
    }
  }, [state]);
  return (
    <>
      <TabsNav />
      <ContentStyle>
        <Formik
          initialValues={{ NotePharmacist: "", ApplyToAll: false }}
          onSubmit={() => {
            sendToCancelRx();
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Grid
                container
                item
                xs={12}
                spacing={2}
                alignItems="center"
                justifyContent="flex-start"
              >
                {" "}
                <Grid item xs={12}>
                  <Typography
                    component="h6"
                    color="primary"
                    variant="h6"
                    marginBottom={2}
                  >
                    Cancel Prescriptions
                  </Typography>{" "}
                </Grid>
              </Grid>
              <SummaryBoxScroll>
                {stateData?.map((eachItem: any, index: any) => (
                  <SummaryBox className="pdr0" key={index}>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={2}
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <Grid item xs={12} md={4}>
                        <Box className="lblval chk">
                          <YSCheckBox
                            className="fill checkbox"
                            name={`OnPriority ${eachItem?.rxNumber}`}
                            label=""
                            onChange={(e: any) => {
                              handleChangeCheckBox(eachItem?.rxNumber, e);
                            }}
                          />{" "}
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Rx No
                          </Typography>
                          <Typography component="div" variant="body2">
                            {eachItem?.rxNumber}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Rx Date
                          </Typography>
                          <Typography component="div" variant="body2">
                            {eachItem?.rxDate}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Fmlry. Status
                          </Typography>
                          <Typography component="div" variant="body2">
                            {eachItem?.formularyStatus}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <Box className="lblval">
                          <Typography
                            component="div"
                            variant="body2"
                            color={"primary"}
                            fontWeight={600}
                          >
                            {eachItem?.drugDescription}
                          </Typography>
                          {eachItem?.deaClassCode && (
                            <Typography
                              component="div"
                              className="ScheduledDrugLabel"
                              variant="body2"
                            >
                              {eachItem?.deaClassCode}
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Co-Pay
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.copay}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            SIG
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.sig}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Qualifier
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.qtyQualifier}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Quantity
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.quantity}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            No. Of Refills
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.refills}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Substitutions
                          </Typography>{" "}
                          <Typography component="div" variant="body2">
                            {eachItem?.substitution}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="div"
                            variant="body2"
                            fontWeight={600}
                          >
                            Note to Pharmacist
                          </Typography>{" "}
                          <Typography
                            component="div"
                            variant="body2"
                          ></Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Box className="lblval">
                          <Typography
                            component="label"
                            variant="body2"
                            fontWeight={600}
                          >
                            Pharmacy
                          </Typography>{" "}
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={
                              <PharmacyDetails
                                row={eachItem?.pharmacyDetails}
                              />
                            }
                            className="w316"
                          >
                            <Typography
                              component="div"
                              variant="body2"
                              color={"primary"}
                            >
                              {eachItem?.pharmacyDetails?.pharmacyName}
                            </Typography>
                          </HtmlTooltip>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            gap: 10,
                            marginBottom: 10,
                          }}
                        >
                          <Typography
                            component="div"
                            variant="body2"
                            fontWeight={600}
                            color={greyColor}
                            style={{
                              marginTop: 8,
                              whiteSpace: "nowrap",
                              minWidth: 125,
                            }}
                          >
                            Note to Pharmacist
                          </Typography>{" "}
                          <DRxInputStyle className="w-auto brs10">
                            {" "}
                            <TextField
                              id={`Note${eachItem?.rxNumber}`}
                              key={eachItem?.rxNumber}
                              name="NotePharmacist"
                              type="text"
                              className="input"
                              disabled={false}
                              label={"Note to Pharmacist"}
                              onChange={(e: any) => {
                                setStateData((prevState: any) =>
                                  prevState.map((item: any, i: any) => {
                                    if (applyAll) {
                                      return {
                                        ...item,
                                        instructions: e.target.value,
                                      };
                                    } else if (i === index) {
                                      return {
                                        ...item,
                                        instructions: e.target.value,
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                              value={eachItem?.instructions}
                            />
                          </DRxInputStyle>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box className={"checkboxgrp right"}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={applyAll}
                                onChange={() => setApplyAll(!applyAll)}
                                name={eachItem?.rxNumber}
                                key={index}
                                value={applyAll}
                              />
                            }
                            label="Apply to All"
                          />

                          {/* <YSButton
                            className="fill"
                            children="ApplyToAll"
                            key={index}
                            id={`A${index}`}
                            onClick={(e: any) => {
                              //setApplyAll(!applyAll);
                            }}
                            variant={"contained"}
                            size={"medium"}
                          /> */}
                        </Box>
                      </Grid>
                    </Grid>
                  </SummaryBox>
                ))}
              </SummaryBoxScroll>{" "}
              <Grid item xs={12}>
                <BtnGroupStyle className="right">
                  <YSButton
                    onClick={removeCancelRx}
                    className=""
                    children={"* Remove CancelRx"}
                    size={"large"}
                    type="button"
                    color="primary"
                    variant="outlined"
                  />
                  <YSButton
                    onClick={null}
                    className=""
                    children={
                      loading ? (
                        <CircularProgress color="inherit" size={28} />
                      ) : (
                        "Send CancelRx"
                      )
                    }
                    size={"large"}
                    type="submit"
                    color="primary"
                    variant="contained"
                  />
                </BtnGroupStyle>
              </Grid>
            </Form>
          )}
        </Formik>{" "}
      </ContentStyle>
      <DialogPopup
        title="CancelRx Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="left"
        >
          {sendCancelRxData?.statusCode === 0 ? (
            <Grid item xs={12} textAlign={"center"}>
              <CheckCircleOutlineIcon
                style={{ height: 70, width: 70 }}
                color="success"
              />
            </Grid>
          ) : sendCancelRxData?.statusCode === 2 ? (
            <Grid item xs={12} textAlign={"center"}>
              <CancelOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="error"
              />
            </Grid>
          ) : sendCancelRxData?.statusCode === 1 ? (
            <Grid item xs={12} textAlign={"center"}>
              <ErrorOutlineOutlinedIcon
                style={{ height: 70, width: 70 }}
                color="warning"
              />
            </Grid>
          ) : null}
          {sendCancelRxData?.successReturnList?.length >= 1 && (
            <>
              <Typography component="div" variant="subtitle2" fontWeight={600}>
                Successful transactions :
              </Typography>
              <ul>
                {sendCancelRxData?.successReturnList?.map((each: any) => (
                  <li key={each}>
                    <Grid item xs={12} textAlign={"left"}>
                      <Typography
                        color={"primary"}
                        component={"div"}
                        variant={"body2"}
                        fontWeight={600}
                      >
                        {each}
                      </Typography>
                    </Grid>
                  </li>
                ))}
              </ul>
            </>
          )}
          {sendCancelRxData?.failureReturnList?.length >= 1 && (
            <>
              <Typography component="div" variant="subtitle2" fontWeight={600}>
                Failure transactions :
              </Typography>
              <ul>
                {sendCancelRxData?.failureReturnList?.map((each: any) => (
                  <li key={each}>
                    <Grid item xs={12} textAlign={"left"}>
                      <Typography
                        color={"primary"}
                        component={"div"}
                        variant={"body2"}
                        fontWeight={600}
                      >
                        {each}
                      </Typography>
                    </Grid>
                  </li>
                ))}
              </ul>
            </>
          )}
        </Grid>{" "}
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}

const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyName ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.twentyFourHourFlag ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.storeNo ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyAddress ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.landmark ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.city ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.state ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.zip ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.pharmacyPhone ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {row?.faxNo ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
